import * as React from "react";
const SVGComponent = ({ size = 24, color = "currentColor", className, style, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ ...style, color }}  // color를 style로 전달
      {...props}
    >
      <path
        d="M4 7.69208C4 7.48926 4 7.38785 4.00877 7.30244C4.09336 6.47863 4.76876 5.82693 5.62253 5.7453C5.71105 5.73684 5.82181 5.73684 6.04335 5.73684C6.12871 5.73684 6.17139 5.73684 6.20763 5.73472C6.67037 5.70768 7.07557 5.42588 7.24849 5.01084C7.26203 4.97834 7.27469 4.9417 7.3 4.86842C7.32531 4.79514 7.33797 4.7585 7.35151 4.726C7.52443 4.31097 7.92963 4.02916 8.39237 4.00212C8.42861 4 8.46863 4 8.54868 4H11.4513C11.5314 4 11.5714 4 11.6076 4.00212C12.0704 4.02916 12.4756 4.31097 12.6485 4.726C12.662 4.7585 12.6747 4.79514 12.7 4.86842C12.7253 4.9417 12.738 4.97834 12.7515 5.01084C12.9244 5.42588 13.3296 5.70768 13.7924 5.73472C13.8286 5.73684 13.8713 5.73684 13.9566 5.73684C14.1782 5.73684 14.289 5.73684 14.3775 5.7453C15.2312 5.82693 15.9066 6.47863 15.9912 7.30244C16 7.38785 16 7.48926 16 7.69208V12.2211C16 13.1938 16 13.6801 15.8038 14.0517C15.6312 14.3785 15.3559 14.6442 15.0172 14.8107C14.6321 15 14.1281 15 13.12 15H6.88C5.87191 15 5.36786 15 4.98282 14.8107C4.64413 14.6442 4.36876 14.3785 4.19619 14.0517C4 13.6801 4 13.1938 4 12.2211V7.69208Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.3947C11.3255 12.3947 12.4 11.3579 12.4 10.0789C12.4 8.79997 11.3255 7.76316 10 7.76316C8.67452 7.76316 7.6 8.79997 7.6 10.0789C7.6 11.3579 8.67452 12.3947 10 12.3947Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SVGComponent;
